export const apiEndpoint = process.env.API_ENDPOINT;
//# sourceMappingURL=Environment.js.map